import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { noop } from 'helpers/GlobalHelper';
import Tile from 'components/TileLegacy';
import { Tile as TileV2 } from 'componentsV2/Tile';
// import PosterGrid from 'componentsV2/PosterGrid';
import Style from './TileGrid.module.scss';

const EXPAND_BEHAVIOR_PAGINATION = 'pagination';
const EXPAND_BEHAVIOR_TOGGLE = 'toggle';
const EXPAND_BEHAVIOR_FROM_COLLAPSED_SET = 'toggleFromCollapsedSet';

class TileGrid extends Component {
  constructor() {
    super();
    this.state = {
      hasMore: false,
      expanded: false,
      page: 1,
    };
    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { items, toggleLimit, scrollSeeLess } = this.props;
    const { expanded, hasMore } = this.state;
    const { expanded: prevExpanded } = prevState;
    const count = items && items.length ? items.length : 0;

    const newHasMore = toggleLimit < count;
    if (hasMore !== newHasMore) {
      this.setState({ hasMore: newHasMore });
    }

    if (!expanded && prevExpanded && scrollSeeLess) {
      this.targetDiv.scrollIntoView(false);
    }
  }

  toggleShowMore() {
    const {
      expandBehavior,
      items,
      toggleLimit,
      tileGridTrackButtonClick,
      onToggleShowMore,
    } = this.props;
    const { expanded, page } = this.state;
    const {
      paginationLessButton: toggleLessText,
      paginationMoreButton: toggleMoreText,
    } = window.Language;
    const toggleText = expanded ? toggleLessText : toggleMoreText;
    const newToggleLimit = toggleLimit * page;
    const count = items && items.length ? items.length : 0;

    if (onToggleShowMore) onToggleShowMore();

    if (tileGridTrackButtonClick) {
      tileGridTrackButtonClick({ text: _.trim(toggleText) });
    }

    if (expandBehavior === EXPAND_BEHAVIOR_PAGINATION) {
      // handle pagination.
      if (!expanded && newToggleLimit + toggleLimit >= count) {
        this.setState({ expanded: true });
        return;
      }
      if (expanded && newToggleLimit + toggleLimit >= count) {
        this.setState({ expanded: false, page: 1 });
        return;
      }
      // increase pages on pagination.
      this.setState({ page: page + 1 });
      return;
    }

    this.setState({
      expanded: !expanded,
    });
  }

  filteredItems() {
    const { itemsCollapsed, expandBehavior, items, toggleLimit } = this.props;
    const { page } = this.state;
    const togglePaginated = toggleLimit ? toggleLimit * page : null;

    switch (expandBehavior) {
      case EXPAND_BEHAVIOR_FROM_COLLAPSED_SET:
        return itemsCollapsed;
      default:
        return items.slice(0, togglePaginated);
    }
  }

  renderDummyBlocks() {
    const { dummyBlocksCount, headline } = this.props;
    const dummyBlocks = [];
    const tileContainerStyle = classNames([
      Style.searchInlineTileContainer,
      headline && Style.searchInlineTileContainerWithTitle,
    ]);
    for (let i = 0; i < dummyBlocksCount; i += 1) {
      dummyBlocks.push(<div className={tileContainerStyle} style={{ visibility: 'hidden' }} />);
    }
    return dummyBlocks;
  }

  render() {
    const {
      account,
      bookmarks,
      collectionItemViewed,
      collectionType,
      context,
      customTileClick,
      disableDescriptions,
      disableHoverStateActionButtons,
      displayUpsellCTA,
      expandBehavior,
      getButtons,
      gridIndex,
      gridStyle,
      gridTitle,
      gridType,
      headline,
      isAuthenticated,
      isLastSection,
      isNonCategorySearch,
      isSeriesDetailPage,
      items,
      onSeeAllClick,
      onPlayClick,
      onTileClick,
      onTitleClick,
      padding,
      preventLazyLoad,
      processor,
      renderImage,
      segmentPlaylistButtonAction,
      separator,
      shouldDisplayNetworkLogo,
      showUpgradeCTA,
      tab,
      tealiumActions,
      tileDetailToggle,
      tileIndexOffset,
      tileTheme,
      tileType,
      tileV2Type,
      toggleLimit,
      toggleVideoModal,
      usePlayButtonThin,
    } = this.props;

    const { expanded, page } = this.state;
    const classes = classNames(Style.container, Style[gridType]);
    const togglePaginated = toggleLimit ? toggleLimit * page : null;
    const filteredItems = !expanded && togglePaginated ? this.filteredItems() : items;
    // Toggle count would be the number of items to show initially
    const toggleCount = toggleLimit || 0;
    const count = items && items.length ? items.length : 0;
    const hasMore = toggleLimit < count;
    let loadMoreElement = null;
    let itemIndex = -1;

    if (
      hasMore ||
      (count > toggleCount && toggleCount > 0) ||
      expandBehavior === EXPAND_BEHAVIOR_TOGGLE ||
      expandBehavior === EXPAND_BEHAVIOR_PAGINATION
    ) {
      const suppressMore =
        expandBehavior === EXPAND_BEHAVIOR_PAGINATION &&
        !(hasMore || (count > toggleCount && toggleCount > 0));
      const params = {
        theme: Style,
        toggleFunction: this.toggleShowMore,
        expanded,
        hasMore,
        suppressMore,
      };
      loadMoreElement = getButtons && typeof getButtons === 'function' ? getButtons(params) : null;
    } else if (tileIndexOffset) {
      itemIndex -= tileIndexOffset;
    }
    const contents = _.flatMap(filteredItems, (item, index) => {
      if (!item) return null;
      const modifiedItem = item;
      modifiedItem.theme = tileTheme;
      modifiedItem.displayUpsellCTA = displayUpsellCTA;
      const processed = processor({
        account,
        bookmarks,
        gridIndex,
        item: modifiedItem,
        itemIndex,
        isAuthenticated,
        toggleVideoModal,
        theme: tileTheme,
        hasAccount: !!account,
      });
      if (!processed) return null;

      itemIndex += 1;

      const tileProps = {
        ...processed,
        account,
        collectionItemViewed,
        collectionType,
        context,
        customTileClick,
        disableDescriptions,
        disableHoverStateActionButtons,
        displayUpsellCTA,
        gridIndex,
        gridTitle,
        isSeriesDetailPage,
        itemIndex,
        key: `${processed?.id}-${context}`,
        onSeeAllClick,
        onPlayClick,
        onTileClick,
        onTitleClick,
        preventLazyLoad,
        renderImage,
        segmentPlaylistButtonAction,
        shouldDisplayNetworkLogo,
        showUpgradeCTA,
        tab,
        tealiumActions,
        theme: tileTheme,
        tileType,
        toggleEnabled: tileDetailToggle && !processed?.preventToggle,
        upsellButtonClick: onTitleClick,
        usePlayButtonThin,
      };
      const tileComponent = tileV2Type ? (
        <TileV2 type={tileV2Type} {...tileProps} />
      ) : (
        <Tile {...tileProps} isTileGrid />
      );

      if (isNonCategorySearch) {
        const tileContainerStyle = classNames([
          Style.searchInlineTileContainer,
          headline && Style.searchInlineTileContainerWithTitle,
        ]);
        return (
          <div className={tileContainerStyle}>
            {headline && index === 0 && <h1 className={Style.searchInlineTitle}>{headline}</h1>}
            {tileComponent}
          </div>
        );
      }
      return tileComponent;
    });

    if (isNonCategorySearch) {
      return (
        <>
          {contents}
          {isLastSection && this.renderDummyBlocks()}
        </>
      );
    }
    return (
      <div
        className={classes}
        ref={div => {
          this.targetDiv = div;
        }}
      >
        <div className={Style.grid} style={gridStyle}>
          {contents}
        </div>
        {loadMoreElement}
        {separator ? <hr className={Style.hr} /> : null}
        {padding && <div className={Style.padding} />}
      </div>
    );
  }
}

TileGrid.propTypes = {
  account: PropTypes.shape({}),
  bookmarks: PropTypes.shape({}),
  collectionItemViewed: PropTypes.func,
  collectionType: PropTypes.string,
  context: PropTypes.string,
  customTileClick: PropTypes.func,
  disableDescriptions: PropTypes.bool,
  disableHoverStateActionButtons: PropTypes.bool,
  displayUpsellCTA: PropTypes.bool,
  dummyBlocksCount: PropTypes.number,
  expandBehavior: PropTypes.string,
  getButtons: PropTypes.func,
  gridIndex: PropTypes.number,
  gridStyle: PropTypes.shape({}),
  gridTitle: PropTypes.string,
  gridType: PropTypes.oneOf([
    'grid-2-1',
    'grid-3-1',
    'grid-3-2',
    'grid-4-1',
    'grid-4-2',
    'grid-4-2-1',
    'grid-4-3',
    'grid-4-3-1',
    'grid-5-4-2-1',
    'grid-5-4-3-1',
    'grid-horizontal-3',
  ]).isRequired,
  headline: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isLastSection: PropTypes.bool,
  isNonCategorySearch: PropTypes.bool,
  isSeriesDetailPage: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  itemsCollapsed: PropTypes.bool,
  onPlayClick: PropTypes.func,
  onSeeAllClick: PropTypes.func,
  onTileClick: PropTypes.func,
  onTitleClick: PropTypes.func,
  onToggleShowMore: PropTypes.func,
  padding: PropTypes.bool,
  preventLazyLoad: PropTypes.bool,
  processor: PropTypes.func,
  renderImage: PropTypes.func,
  scrollSeeLess: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
  separator: PropTypes.bool,
  shouldDisplayNetworkLogo: PropTypes.bool,
  showUpgradeCTA: PropTypes.bool,
  tab: PropTypes.shape({}),
  tealiumActions: PropTypes.shape({}),
  tileDetailToggle: PropTypes.bool,
  tileGridTrackButtonClick: PropTypes.func,
  tileIndexOffset: PropTypes.number,
  tileTheme: PropTypes.shape({}),
  tileType: PropTypes.string,
  tileV2Type: PropTypes.string,
  toggleLimit: PropTypes.number,
  toggleVideoModal: PropTypes.func,
  usePlayButtonThin: PropTypes.bool,
};

TileGrid.defaultProps = {
  account: {},
  collectionItemViewed: noop,
  collectionType: null,
  context: null,
  customTileClick: null, // This needs to remain null and not noop as it break logic further down.
  disableDescriptions: false,
  disableHoverStateActionButtons: false,
  displayUpsellCTA: false,
  dummyBlocksCount: 0,
  expandBehavior: null,
  getButtons: noop,
  gridIndex: null,
  gridStyle: {},
  gridTitle: null,
  headline: '',
  isAuthenticated: null,
  isNonCategorySearch: false,
  isSeriesDetailPage: false,
  items: [],
  itemsCollapsed: null,
  onSeeAllClick: noop,
  onTileClick: noop,
  onTitleClick: noop,
  onToggleShowMore: null,
  padding: false,
  preventLazyLoad: false,
  processor: noop,
  renderImage: noop,
  scrollSeeLess: null,
  segmentPlaylistButtonAction: noop,
  separator: false,
  shouldDisplayNetworkLogo: false,
  showUpgradeCTA: false,
  tab: null,
  tealiumActions: {},
  tileDetailToggle: true,
  tileGridTrackButtonClick: noop,
  tileIndexOffset: null,
  tileTheme: {},
  tileType: null,
  tileV2Type: null,
  toggleLimit: null,
  toggleVideoModal: noop,
  usePlayButtonThin: false,
};

export default TileGrid;
